import { Stack, Heading, Text, HStack, Tag,  Wrap, WrapItem } from "@chakra-ui/react";
import React from "react";
import { InputRowGrid } from "../../shared/InputRowGrid";
import { BsPlusCircleFill } from "react-icons/bs";

export default function JobExpertise() {
  return (
    <Stack gap={5}>
      <InputRowGrid
        heading={
          <Stack>
            <Heading
              fontWeight={"semibold"}
              mt={"10px"}
              fontSize={{ base: "20px", lg: "26px" }}
              textAlign={{ base: "", md: "start" }}
            >
              Devices
            </Heading>
            <Text
              fontWeight={"semibold"}
              fontSize={{ base: "16px", lg: "22px" }}
              textAlign={{ base: "", md: "start" }}
            >
              (optional)
            </Text>
          </Stack>
        }
        text="What Skills and expertise are most important to you in Mobile App Development?"
        input={
          <AddMoreBox
            options={["Phone", "Tablet", "Watch", "Virtual Reality", "TV"]}
            addMore="Devices"
          />
        }
      />
      <InputRowGrid
        heading={
          <Stack>
            <Heading
              fontWeight={"semibold"}
              mt={"10px"}
              fontSize={{ base: "20px", lg: "26px" }}
              textAlign={{ base: "", md: "start" }}
            >
              Mobile Platforms
            </Heading>
            <Text
              fontWeight={"semibold"}
              fontSize={{ base: "16px", lg: "22px" }}
              textAlign={{ base: "", md: "start" }}
            >
              (optional)
            </Text>
          </Stack>
        }
        
        input={
          <AddMoreBox
            options={["Hybrid", "Native", "Android", "IOS", "Windows","IPadOS"]}
            addMore="Platforms"
          />
        }
      />
      <InputRowGrid
        heading={
          <Stack>
            <Heading
              fontWeight={"semibold"}
              mt={"10px"}
              fontSize={{ base: "20px", lg: "26px" }}
              textAlign={{ base: "", md: "start" }}
            >
              Apple APIs Dev
            </Heading>
            <Text
              fontWeight={"semibold"}
              fontSize={{ base: "16px", lg: "22px" }}
              textAlign={{ base: "", md: "start" }}
            >
              (optional)
            </Text>
          </Stack>
        }
        
        input={
          <AddMoreBox
            options={["iAd", "Scenekit", "Metal", "iBeacon", "SpriteKit","Core Bluetooth"]}
            addMore="Platforms"
          />
        }
      />
      <InputRowGrid
        heading={
          <Stack>
            <Heading
              fontWeight={"semibold"}
              mt={"10px"}
              fontSize={{ base: "20px", lg: "26px" }}
              textAlign={{ base: "", md: "start" }}
            >
              Mobile Languages
            </Heading>
            <Text
              fontWeight={"semibold"}
              fontSize={{ base: "16px", lg: "22px" }}
              textAlign={{ base: "", md: "start" }}
            >
              (optional)
            </Text>
          </Stack>
        }
        
        input={
          <AddMoreBox
            options={["Swift", "Java", "Kotlin", "Javascript", "Scala","Objective-C"]}
            addMore="Languages"
          />
        }
      />
    </Stack>
  );
}

const AddMoreBox = ({ options, addMore }) => {
  const [list, setList] = React.useState([]);
  const handleClick = (index) => {
    const indexInSelection = list.indexOf(index);
    if (indexInSelection === -1) {
      setList([...list, index]);
    } else {
      setList(list.filter((i) => i !== index));
    }
  };
  return (
    <HStack
      px={2}
      py={3}
      border="1px solid #c5c5c5"
      rounded="lg"
      justifyContent={"space-between"}
      gap={2}
    >
      <Wrap spacing={2}>
        {options.map((item, index) => {
          return (
            <WrapItem key={index}>
            <Tag
              size="lg"
              bgColor={
                list.includes(index) ? "rgba(0,141,219,0.24)" : "#F1F2F4"
              }
              cursor="pointer"
              onClick={() => handleClick(index)}
              color="black"
              fontWeight="regular"
            >
              {item}
            </Tag>
            </WrapItem>
          );
        })}
        <WrapItem sx={{marginLeft:"auto !important"}}
        >
        <HStack
        color="brand.500"
        fontWeight="medium"
        fontSize={{ base: "14px", md: "18px" }}
        cursor="pointer"
        p={2}
        display={{base:"flex",md:"none"}}
        
      >
        <BsPlusCircleFill />
        <Text w='max-content'>Add More {addMore}</Text>
      </HStack>
        </WrapItem>
      </Wrap>
      <HStack
        color="brand.500"
        fontWeight="medium"
        fontSize={{ base: "14px", md: "18px" }}
        cursor="pointer"
        p={2}
        display={{base:"none",md:"flex"}}
      >
        <BsPlusCircleFill />
        <Text w='max-content'>Add More {addMore}</Text>
      </HStack>
    </HStack>
  );
};
